import Dropdown from '@/components/Dropdown/index';
import API from '@/services/api/eclips';
import rem from '@/utils/rem';
import React, { useEffect } from 'react';

function CaseOwnerDropdown({
	placeholder = 'Package Owner',
	value,
	setValue,
	style = { width: rem(280) }
}) {
	const [options, setOptions] = React.useState([])
	const { getUsers } = API;

	useEffect(() => {
		getUsers().then(res => {
			setOptions(res?.data?.data)
		});
	}, [])

	return (
		<Dropdown
			placeholder={placeholder}
			value={value?.email}
			placement="bottom"
			style={style}
		>
			{options.map((option, index) => {
				return (
					<Dropdown.Item key={index}
						id={option.email}
						onClick={() => setValue(option)}
					>
						{option.email}
					</Dropdown.Item>
				)
			})}
		</Dropdown>
	)
}

export default CaseOwnerDropdown
